<script lang="ts">
    import Close from './close.svg'
    import { fade } from 'svelte/transition';

    export let visible = false
    export let size = void 0
</script>

{#if visible}
<style>
    body {
        overflow: hidden;
    }
</style>
<div class="modal-custom" transition:fade={{ duration: 250 }} tabindex="-1" style="--Close:url({Close});">
    <div class="modal" on:click={() => { visible = false }}>
        <div class="modal-dialog modal-dialog-centered {size ? `modal-${size}` : ''}" on:click|stopPropagation={() => {}}>
            <div class="modal-content">
                <div class="modal-body">
                    <button on:click={() => { visible = false }} class="btn-close modal-custom__button-close"></button>
                    <slot name="content"></slot>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop show"></div>
</div>
{/if}

<style lang="postcss">
    .modal {
        display: block;
        overflow-y: auto;
    }

    .modal-custom {
        z-index: 9999;
    }

    .modal-content {
        border-radius: 20px;
        background: #181636;
        text-align: left;
        box-shadow: 0 24px 32px rgba(0, 0, 0, 14);
        border: 2px solid #353064;
    }

    .modal-body {
        padding: 30px;
        color: white;
    }

    .modal-custom :global {
        .modal-custom__title {
            font-size: 30px;
            font-weight: 600;
            margin: 5px 0 30px;
            padding-right: 35px;
            line-height: normal;
        }

        .modal-custom__title.text-center {
            text-align: center;
            padding-left: 35px;
        }

        .modal-custom__text {
            font-size: 16px;
        }

        .modal-custom__footer {
            text-align: right;
            margin: 30px 0 0;
            border-top: 2px solid #343168;
            padding-top: 30px;
        }

        .modal-custom__footer button {
            margin-left: 10px;
        }

        .btn-cancel {
            display: inline-block;
            font-size: 16px;
            color: white;
            text-decoration: none;
            font-weight: 500;
            border: 1px solid #CAD5E0;
            padding: 16px 32px;
            border-radius: 6px;
            box-shadow: none !important;
            background: none;
            line-height: 16px;
            transition: .25s;
            cursor: pointer;
        }

        .btn-cancel:hover {
            background: white;
            color: #2E3549;
        }

        .btn-primary {
            font-size: 16px;
            line-height: 1;
            position: relative;
            color: white;
            text-decoration: none;
            border: 0;
            padding: 16px 32px;
            border-radius: 10px;
            background: #FF5D1C;
            font-weight: 500;
            box-shadow: 0 -3px 2px 0 rgba(0, 0, 0, 0.4) inset, 0 2px 2px 0 rgba(255, 255, 255, 0.3) inset;
            transition: .2s;
            cursor: pointer;
        }

        .btn-primary:hover {
            background: #df5118;
            border-color: #df5118;
        }

        .modal-custom__button-close {
            position: absolute;
            background: var(--Close) no-repeat;
            top: 20px;
            right: 20px;
            font-size: 14px;
            opacity: 0.8;
            box-shadow: none !important;
            width: 30px;
            height: 30px;
            transition: .2s;
        }

        .modal-custom__button-close:hover {
            opacity: 1;
        }
    }

    @media(max-width: 991px) {
        .modal-custom :global {
            .modal-custom__title {
                font-size: 20px;
            }

            .modal-custom__button-close {
                top: 16px;
                right: 16px;
            }

            .modal-custom__footer button {
                padding: 12px 22px;
                font-size: 14px;
            }

            .modal-custom__text {
                font-size: 14px;
            }
        }
    }

    @media(max-width: 767px) {
        .modal-dialog {
            width: 90%;
            margin: .5rem auto;
        }

        .modal-custom :global {
            .modal-custom__title {
                margin: -5px 0 10px;
            }

            .modal-body {
                padding: 17px 15px 15px;
            }

            .modal-custom__button-close {
                top: 14px;
                right: 15px;
            }

            .modal-custom__footer {
                margin: 15px 0 0;
            }
        }
    }
</style>
